<template>
  <div>
    <v-text-field
      readonly
      class="custom-datepicker-input"
      outline
      name="startTime"
      :value="value"
      single-line
      :hide-details="$attrs['hide-details'] || true"
      v-bind="$attrs"
      append-icon="access_time"
      style="min-width: 150px"
      @click:append="show = true"
      @click="show = true"
      @click:clear="$emit('onChange', '')"
    ></v-text-field>
    <v-dialog v-model="show" scrollable max-width="350px">
      <v-card>
        <v-card-text>
          <VueCtkDateTimePicker
            :color="$vuetify.theme.primary"
            :value="value"
            v-bind="$attrs"
            :no-value-to-custom-elem="true"
            inline
            @input="$emit('onChange', $event)"
          >
          </VueCtkDateTimePicker>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="show = false">{{ $t('submit') }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    VueCtkDateTimePicker
  },
  props: ['value'],
  data() {
    return {
      show: false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/CustomTimepicker2.vue